import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { Table, UncontrolledTooltip } from "reactstrap";
import { RiAlertLine, RiCheckLine, RiCloseLine, RiInformationLine, RiQuestionLine } from "react-icons/ri";

const RiskScore = ({
    t,
    setActiveAccordion,
    activeAccordion,
    detailsQuery
}) => {
    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const {
        quickcheck,
        claims_indicator,
        export_indicator,
        indate_indicator
    } = organizationData || {};

    return (
        <Accordion.Item 
            onClick={() => setActiveAccordion('operational-events')}
            className={activeAccordion === 'operational-events' ? 'active' : ''}
            eventKey={'operational-events'}
        >
            <Accordion.Header>
                <RiAlertLine size="24" className="me-2" />
                <span>
                    {t('Legal & Operational Events')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <Table striped bordered hover size="sm">
                    <tbody>
                        <tr>
                            <th
                                style={{
                                    width: '30%'
                                }}
                            >
                                {t('Disaster')}
                                <span
                                    id="tooltip-disaster"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-disaster"
                                >
                                    {t('Indicates if special events exist in the D&B database for the subject company concerning disasters such as fire, flood, earthquake, hurricane, etc.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.disaster === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.disaster === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Financial Embarrassment')}
                                <span
                                    id="tooltip-financial_embarrassment"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-financial_embarrassment"
                                >
                                    {t('Indicates whether record of an open or closed bankruptcy, receivership, liquidation, discontinuance with unpaid obligations or an equivalent event related to the company exists in the D&B database. Other specific event categories relate to administrator appointments and orders, Meeting of Creditors, Wind Up Petitions and Statements of Insolvency. The public record item(s) that may have impacted this indicator may have been closed or dismissed prior to the date this indicator was extracted from D&B’s file.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.financial_embarrassment === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.financial_embarrassment === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Financial Legal Events')}
                                <span
                                    id="tooltip-financial_legal_events"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-financial_legal_events"
                                >
                                    {t('Indicates whether special events exist in D&B’s database that denote financial embarrassment or legal filings related to the business. These include Public Sales, Change of 50% of Assets, Public Filings, Letter of Liability, and Principals Antecedents – Bankruptcy (e.g., voluntary winding ups). The public record item(s) that may have impacted this indicator may have been closed or dismissed prior to the date this indicator was extracted from D&B’s file.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.financial_legal_events === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.financial_legal_events === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Suit / Judgement')}
                                <span
                                    id="tooltip-suit_judgement"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-suit_judgement"
                                >
                                    {t('Indicates whether open suit(s), judgment(s), petition(s) and/or payment remarks exist in the D&B database for the company. A lawsuit may be an action to clear title to property and does not necessarily imply a claim for money against the subject. The public record item(s) that may have impacted this indicator may have been paid, terminated, vacated or released prior to the date this indicator was extracted from D&B’s file.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.suit_judgement === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.suit_judgement === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Criminal Proceedings')}
                                <span
                                    id="tooltip-criminal_proceedings"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-criminal_proceedings"
                                >
                                    {t('The Criminal Proceedings indicator provides an indication of whether criminal proceedings related to the case exist in D&B’s database.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.criminal_proceedings === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.criminal_proceedings === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Other Events')}
                                 <span
                                    id="tooltip-other_events"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-other_events"
                                >
                                    {t('Indicates that special events not otherwise specified exist in the D&B database for the business.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.other_events === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.other_events === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Operational Events')}
                                <span
                                    id="tooltip-operational_events"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-operational_events"
                                >
                                    {t('Indicates whether special events exist in the D&B database that concern changes to the business’ operations. These include categories such as name changes; management changes; changes of legal form, control, or capital; business wind up or closure; or moves.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.operational_events === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.operational_events === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Claims Indicator')}
                                <span
                                    id="tooltip-claims_indicator"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-claims_indicator"
                                >
                                    {t('Indicates if open claim(s), lien(s), protested bill(s), warrant(s), Social Securities Summon(s) and/or equivalent exist in the D&B database for the case company.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {claims_indicator === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : claims_indicator === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Secured Filings')}
                                <span
                                    id="tooltip-secured_filings"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-secured_filings"
                                >
                                    {t('Indicates whether open secured filings such as UCC filings, secured charges/mortgages pledgings, or equivalent exist for the business in D&B’s database. Only applicable in the U.S.A., not in the Netherlands.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {quickcheck.secured_filings === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : quickcheck.secured_filings === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('Export Indicator')}</th>
                            <td>
                                {export_indicator === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : export_indicator === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {t('Indate Indicator')}
                                <span
                                    id="tooltip-indate_indicator"
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}>
                                    <RiInformationLine />
                                </span>
                                <UncontrolledTooltip
                                    target="tooltip-indate_indicator"
                                >
                                    {t('Indicates whether the company data is up to date. If data for this company exists but is out of date, the value No (Investigation Recommended) is returned.')}
                                </UncontrolledTooltip>
                            </th>
                            <td>
                                {indate_indicator === true ? (
                                    <>
                                        <RiCheckLine size={20} className="text-primary" />
                                        {t('Yes')}
                                    </>
                                ) : indate_indicator === false ? (
                                    <>
                                        <RiCloseLine size={20} className="text-danger" />
                                        {t('No')}
                                    </>
                                ) : (
                                    <>
                                        <RiQuestionLine size={20} className="text-secondary" />
                                        {t('Unknown')}
                                    </>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    RiskScore
);